import React, { useEffect, useState } from 'react';
import { Slider } from '../components/Slider';
import SideMenu from '../components/SideMenu';
import { useParams } from 'react-router-dom';
import { NBAaccreditation } from '../components/accreditation-reports/NBAaccreditation';
import { EoaReports } from '../components/accreditation-reports/EoaReports';
import { MonitoringReports } from '../components/accreditation-reports/MonitoringReports';
import { AuditReports } from '../components/accreditation-reports/AuditReports';
import { AisheReports } from '../components/accreditation-reports/AisheReports';
import { InfraDetails } from '../components/accreditation-reports/InfraDetails';
import { FireSafety } from '../components/accreditation-reports/FireSafety'; // Assuming this component exists

export const AccreditationReports = () => {
    const { page } = useParams();
    const [monitoringReport, setMonitoringReport] = useState([]);
    const [eoaData, setEoaData] = useState([]);
    const [auditReport, setAuditReport] = useState([]);
    const [nbaAccreditation, setNbaAccreditation] = useState([]);
    const [aisheReport, setAisheReport] = useState([]); // New state for AISHE Report
    const [infraDetails, setInfraDetails] = useState([]);
    const [fireSafety, setFireSafety] = useState([]);
    let MenuLinks = [
        { name: 'NBA Accreditation', path: '/accreditation-reports/nba-accreditation' },
        { name: 'EOA (AICTE) Reports', path: '/accreditation-reports/eoa-reports' },
        { name: 'Monitoring Report', path: '/accreditation-reports/monitoring-reports' },
        { name: 'Audit Report', path: '/accreditation-reports/audit-reports' },
        { name: 'AISHE Report', path: '/accreditation-reports/aishe-reports' }, // New menu link for AISHE Report
        { name: 'Infrastructure Details', path: '/accreditation-reports/infra-details' },
        { name: 'Fire Safety Certificate', path: '/accreditation-reports/fire-safety' }
    ];

   

    return (
        <>
            <Slider />
            <div className="main-container">
                <div className="text-center">
                    <h1 className="heading"><span className='heading-red'>Accreditation</span> and Reports</h1>
                </div>
                <div className="dynamic-container">
                    <div className="dynamic-change-container">
                        {page === 'nba-accreditation' && <NBAaccreditation data={nbaAccreditation} />}
                        {page === 'eoa-reports' && <EoaReports data={eoaData} />}
                        {page === 'monitoring-reports' && <MonitoringReports data={monitoringReport} />}
                        {page === 'audit-reports' && <AuditReports data={auditReport} />}
                        {page === 'aishe-reports' && <AisheReports data={aisheReport} />}  {/* Render AISHE Report */}
                        {page === 'infra-details' && <InfraDetails data={infraDetails} />}
                        {page === 'fire-safety' && <FireSafety data={fireSafety} />}
                    </div>
                    <SideMenu links={MenuLinks} />
                </div>
            </div>
        </>
    );
};
